import React from 'react';
import { Check, X } from 'lucide-react';

export const PASSWORD_RULES = [
  { id: 'len', label: 'Mínimo 8 caracteres', test: (p) => p.length >= 8 },
  { id: 'upper', label: 'Uma letra maiúscula (A-Z)', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'Uma letra minúscula (a-z)', test: (p) => /[a-z]/.test(p) },
  { id: 'digit', label: 'Um número (0-9)', test: (p) => /\d/.test(p) },
  { id: 'special', label: 'Um caractere especial (!@#$%...)', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const isPasswordValid = (password) =>
  PASSWORD_RULES.every((r) => r.test(password || ''));

export const passwordsMatch = (password, confirm) =>
  !!password && password === confirm;

const Rule = ({ ok, label }) => (
  <li className="flex items-center gap-2 text-[12px] font-sans">
    <span
      className={`flex h-4 w-4 items-center justify-center rounded-full transition-colors ${
        ok ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-400'
      }`}
    >
      {ok ? <Check className="h-2.5 w-2.5" /> : <X className="h-2.5 w-2.5" />}
    </span>
    <span className={ok ? 'text-emerald-700' : 'text-slate-500'}>{label}</span>
  </li>
);

const PasswordStrengthChecker = ({ password = '', confirm, showMatch = false }) => {
  const matched = confirm !== undefined ? passwordsMatch(password, confirm) : null;

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50/60 p-3 font-sans">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
        Requisitos da senha
      </p>
      <ul className="space-y-1.5">
        {PASSWORD_RULES.map((r) => (
          <Rule key={r.id} ok={r.test(password || '')} label={r.label} />
        ))}
        {showMatch && confirm !== undefined && (
          <Rule
            ok={!!matched}
            label={matched ? 'Senhas coincidem' : 'Confirmação deve ser igual'}
          />
        )}
      </ul>
    </div>
  );
};

export default PasswordStrengthChecker;
